import React from 'react';
import { PageCreateProduct } from './pages/PageCreateProduct/PageCreateProduct';

function App() {
  return (
    <div className="App">
      <PageCreateProduct />
    </div>
  );
}

export default App;
